import React, {FunctionComponent} from 'react';
import {Classes, Dialog} from '@blueprintjs/core';

import WithWorkspaceContainer from './WithWorkspace';
import WithUserContainer from './WithUser';
import {Entity} from './types';
import {getEntityIcon, getEntityName, getEntityType} from './utils';

import './SharingSettingsDialog.scss';
import WithGroupContainer from './WithGroup';

type Callback = (value?: any) => void;

interface SharingSettingsDialogProps {
  show?: boolean;
  onClose: Callback;
  onShare: Callback;
  entity: Entity;
}

const SharingSettingsDialog: FunctionComponent<SharingSettingsDialogProps> = ({
  show = false,
  onClose,
  onShare,
  entity,
}: SharingSettingsDialogProps) => {
  const title = getEntityName(entity);

  return (
    <Dialog
      className="sharing-settings-dialog-container"
      autoFocus={true}
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
      enforceFocus={true}
      usePortal={true}
      isOpen={show}
      onClose={onClose}
      title={title}
      icon={getEntityIcon(entity)}
    >
      <div className={Classes.DIALOG_BODY + ' sharing-settings-dialog'}>
        <WithWorkspaceContainer
          uid={entity.uid as string}
          sharingSettings={entity.sharing_settings}
          type={getEntityType(entity)}
          onShare={onShare}
        />
        <WithGroupContainer
          uid={entity.uid as string}
          sharingSettings={entity.sharing_settings}
          type={getEntityType(entity)}
          onShare={onShare}
        />
        <WithUserContainer
          uid={entity.uid as string}
          sharingSettings={entity.sharing_settings}
          type={getEntityType(entity)}
          onShare={onShare}
        />
      </div>
    </Dialog>
  );
};

const SharingSettingsDialogContainer: FunctionComponent<SharingSettingsDialogProps> = ({
  show = false,
  onClose,
  onShare,
  entity,
}: SharingSettingsDialogProps) => {
  return (
    <SharingSettingsDialog
      show={show}
      onClose={onClose}
      onShare={onShare}
      entity={entity}
    />
  )
};

export default SharingSettingsDialogContainer;
